import React from "react";

import {
  Button,
  Checkbox,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  AddUserFields,
  deleteUserFields,
  DeleteUserFields,
  getUserFields,
  updateUserFields,
  UpdateUserFields,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import AddCustomFields from "./AddCustomField";

const { Title } = Typography;

const columns = [
  {
    title: "Field",
    dataIndex: "column_name",
    key: "column_name",
    render: (text, data) => {
      return (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      );
    },
    //   render: text => <a href="/">{text}</a>,
  },
  {
    title: "Column Type",
    dataIndex: "column_type",
    key: "column_type",
  },
];
message.config({
  maxCount: 3,
});

const CustomFields = () => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [userFieldsData, setUserFieldsData] = React.useState([]);
  const [totalRecords, setTotalRecords] = React.useState(0);
  // const [rolesData, setCustomFieldsData] = React.useState([]);
  const userFieldsResponse = useSelector(
    (state) => state.companySetting.getUserFields || {},
  );
  const deleteUserFieldsResponse = useSelector(
    (state) => state.companySetting.deleteUserFields || {},
  );
  const addUserFieldsResponse = useSelector(
    (state) => state.companySetting.addUserFields || {},
  );
  const updateUserFieldsResponse = useSelector(
    (state) => state.companySetting.updateUserFields || {},
  );

  React.useEffect(() => {
    // dispatch(getCustomFieldsPermissions({}));
    dispatch(getUserFields({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: {
        response: { fields = [] } = {},
        status = false,
        total_records = 0,
      } = {},
    } = userFieldsResponse;
    if (status) {
      setUserFieldsData(fields);
      setTotalRecords(total_records);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFieldsResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", errors = "", status = "" } = {},
    } = addUserFieldsResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getUserFields({}));
      dispatch({
        type: AddUserFields.RESET,
      });
    }
    if (status === false) {
      dispatch({
        type: AddUserFields.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserFieldsResponse]);
  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {}, success } =
      deleteUserFieldsResponse;
    console.log(res_message, status);

    if (status) {
      setIsModalVisible(false);
      dispatch(getUserFields({}));
      dispatch({
        type: DeleteUserFields.RESET,
      });
    }
    if (success === false) {
      dispatch({
        type: DeleteUserFields.RESET,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteUserFieldsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      updateUserFieldsResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getUserFields({}));
      dispatch({
        type: UpdateUserFields.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserFieldsResponse]);

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  function handleButtonClick(e) {
    showModal();
  }

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure about deleting this field?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteUserFields(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  const tableAction = [
    {
      title: "Mandatory",
      dataIndex: "is_required",
      key: "is_required",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          onChange={(e) =>
            dispatch(
              updateUserFields(
                objectToFormData({
                  id: record.id,
                  is_enable: record.is_enable,
                  view_in_pdf: record.view_in_pdf,
                  is_required: e.target.checked,
                }),
              ),
            )
          }
          checked={status}
          disabled={!hasAccess("users_and_controls", "write")}
        ></Checkbox>
      ),
    },
    // {
    //   title: "Show in PDF",
    //   dataIndex: "view_in_pdf",
    //   key: "view_in_pdf",
    //   render: (status, record) => (
    //     <Checkbox
    //       key={record.id}
    //       onChange={(e) =>
    //         dispatch(
    //           updateUserFields(
    //             objectToFormData({
    //               id: record.id,
    //               is_enable: record.is_enable,
    //               is_required: record.is_required,
    //               view_in_pdf: e.target.checked,
    //             })
    //           )
    //         )
    //       }
    //       checked={status}
    //       disabled={!hasAccess("users_and_controls", "write")}
    //     ></Checkbox>
    //   ),
    // },
    {
      title: "Enable",
      dataIndex: "is_enable",
      key: "is_enable",
      render: (status, record) => (
        <Checkbox
          key={record.id}
          onChange={(e) =>
            dispatch(
              updateUserFields(
                objectToFormData({
                  id: record.id,
                  view_in_pdf: record.view_in_pdf,
                  is_required: record.is_required,
                  is_enable: e.target.checked,
                }),
              ),
            )
          }
          checked={status}
          disabled={!hasAccess("users_and_controls", "write")}
        ></Checkbox>
      ),
    },
    hasAccess("users_and_controls", "write")
      ? {
          title: "Actions",
          key: "action",
          render: (text, record) => (
            <Space key={record.id} size="middle">
              <button onClick={() => showEditModal(record.id)}>
                <img src={EditIcon} alt={"logo"} className="action-logo" />
              </button>
              <button onClick={() => showDeleteModal(record.id)}>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />
              </button>
            </Space>
          ),
        }
      : {},
  ];

  return (
    <>
      {isModalVisible && (
        <Modal
          wrapClassName="custom-field"
          title={
            modalType === "center" ? (
              <>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
                Delete Custom Field
              </>
            ) : (
              <Title level={4}>
                {selectedId ? "Edit Custom Field" : "New Custom Field"} &nbsp;
                <span className="text-small">Enter details and submit</span>
              </Title>
            )
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className={
            modalType === "center"
              ? "center-aligned-modal"
              : "right-alinged-modal-small"
          }
        >
          {modalType === "center" ? (
            renderDeleteOption()
          ) : (
            <AddCustomFields id={selectedId} handleCancel={handleCancel} />
          )}
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Custom Fields`}
          navigation={{
            Home: "/dashboard/",

            "Custom Fields": null,
          }}
        />
      </div>
      {hasAccess("users_and_controls", "write") && (
        <Button
          onClick={handleButtonClick}
          className="mb1 ml1 addNew primaryButton"
          disabled={hasAccess("customre")}
        >
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={userFieldsData}
        className="settingsTable"
        pagination={{
          total: totalRecords || 0,
          onChange: (pagee) => dispatch(getUserFields({ page: pagee })),
        }}
      />
    </>
  );
};

export default CustomFields;
